export const ACTION_SIGNUP = {
  text: 'Jetzt anmelden!',
  to:
    '#anmeldung',
}
